/**
 * Util for applying an alpha value (0–1) to hex colors in #rrggbbaa format.
 *
 * Example: hexColorWithAlpha(theme.ColorWhite, 0.5) => "#ffffff80"
 */
export default function hexColorWithAlpha(color: string, opacity: number) {
  if (opacity < 0 || opacity > 1) {
    throw new Error(
      "RuntimeError: opacity value should be between 0.0 to 1.0.",
    );
  }

  const alphaString = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, "0");

  return color + alphaString;
}
